export const industries = [
'Accountancy',
'Acoustic Consultancy',
'Acoustic Engineering',
'Acting (Performer Actor Actress)',
'Actuary',
'Acupuncture',
'Addressing/Circularising Services',
'Advanced Nurse Practitioner',
'Advanced Paramedic',
'Aerial and Satellite Dish Installation',
'Aerial Supplying',
'Aerobic Instruction',
'After Dinner Speaking',
'Agricultural Consultancy',
'Alarm Installation',
'Alarm Wholesalers',
'Ambulance Technician',
'Amusement Arcade',
'Analytical Chemist',
'Animal Breeding',
'Anthropology',
'Antique Furniture Shop',
'Antiques Shop',
'Aquarium Supplier Shop',
'Arbitration',
'Archaeologist',
'Architectural Surveying',
'Architecture',
'Archivist',
'Aromatherapy',
'Art Criticism',
'Art Dealing',
'Art Gallery',
'Art Studio',
'Art Valuation',
'Artist',
'Artist Materials Shop',
'Arts And Crafts Shop',
'Asbestos Remover',
'Astrology',
'Astronomy',
'Auctioneer',
'Audio/Visual Media Shop',
'Audiologist',
'Audiology',
'Auditing',
'Author',
'Baby Goods Shop',
'Babywear Manufacturers',
'Babywear Shop',
'Bakers Produce Shop (Ex Baking)',
'Bakery',
'Bar',
'Barber',
'Barber Shop',
'Bariatric Nurse',
'Barrister',
'Basket And/Or Brushware Shop',
'Bathroom Design and Installation',
'Bathroom Equipment Shop',
'Beauty Products Shop',
'Beauty Salon',
'Beauty Therapy',
'Bed & Breakfast',
'Bed Shop',
'Bedding Shop',
'Bedroom Designer',
'Beekeeper',
'Beer, Wine and Spirit Wholesalers',
'Belt and Brace Wholesalers - Plastic',
'Belts/Scarves/Gloves Shop',
'Bereavement Counselling',
'Betting Shop',
'Bill Board Poster',
'Biology',
'Biomedical Scientist',
'Blast Cleaning',
'Boarding house',
'Body Repairs (motor)',
'Book Manufacturers',
'Book Shop',
'Bookbinding',
'Bookkeepers',
'Bookmaker',
'Bookmaking - On Course',
'Bookselling',
'Bookselling - Antique',
'Bookselling - Second-hand',
'Botany',
'Bouncy Castle Hiring',
'Boutiques Shop',
'Bridal Wear Shop',
'Builders - All Premises',
'Builders - Commercial New',
'Builders - Commercial New Alteration and Repair',
'Builders - PDH New',
'Builders - PDH New Alteration and Repair',
'Builders Labourer',
'Builders Merchant Shop',
'Building Consultancy',
'Building Management',
'Building Site Inspector',
'Building Society Agent',
'Building Surveying',
'Bulk Earth/Rubble Removing',
'Bureau De Change',
'Burger bar',
'Business Consultancy',
'Business Development Consultancy',
'Butcher Shop',
'Cable Contracting',
'Cafe',
'Cake Making and Decorating',
'Cake Making and Decorating Shop',
'Calibration Consultancy',
'Calligraphy',
'Cameraman',
'Camping And Outdoor Shop',
'Candied Peel Manufacturers',
'Car Accessory Shop',
'Car Park Operator',
'Car Parts Shop',
'Car Wash and Valeting',
'Car Window Etching',
'Caravan / Camp Site Operator',
'Cardiovascular Technologist',
'Career Consultancy',
'Carer / Senior Carer',
'Caretaking Services',
'Carpenters and Joiners',
'Carpet (Oriental/Persian) Shop',
'Carpet Fitting',
'Carpet Shop',
'Carpet, soft furnishing and Upholstery Cleaning (excluding floor cleaning)',
'Cartography',
'Cartoonist',
'Casino',
'Catalogue Distribution',
'Catering - Licenced',
'Catering Consultancy',
'Catering Equipment Supplying Shop',
'Catering Ex Mobile Vans',
'Caulker',
'Cavity Wall Insulation',
'Ceiling Contractor',
'Ceramics And Pottery Shop',
'Chamber of Commerce',
'Chandlery',
'Charity',
'Charity Shop',
'Chartered Engineering',
'Chartered Surveying',
'Chauffeur Services',
'Cheese Shop',
'Chefs',
'Chemist Shop',
'Chemist - Dispensing',
'Chemist - Non Dispensing',
'Childrens Clothing Shop',
'Childrens Entertainer',
'Childrens Nurseries and Playgroups',
'Childrenswear Manufacturers',
'Chimney Sweep',
'China And/Or Glassware Shop',
'Chiropodists and Podiatrists',
'Chiropody',
'Chiropractic',
'Chocolatier',
'Choreography',
'Christmas Goods Supplier',
'Christmas Tree Seller',
'Civil Engineering',
'Cladding Contractors',
'Cleaners - Exterior of Buildings',
'Cleaning Services Excl Exterior Of Buildings Blast and Boilers/Tanks/ducting, windows, soft furnishings pipes and drains',
'Clerical Services',
'Clinical Laboratory Scientist',
'Clinical Pharmacists',
'Clinical Physiologist / Scientist',
'Clinical Psychology',
'Clock & Watch Service & Repair',
'Clock and Watch Repair',
'Clock And Watch Shop',
'Clothing (ex Woollens, Hosiery/Leather) Manufacturers',
'Clothing Accessories Manufacturers (Leather)',
'Clothing Alterations',
'Clothing Hire - Fancy Dress Shop',
'Clothing Hiring Shop',
'Clothing Manufacturers',
'Clothing Shop',
'Clothing Wholesalers',
'Coffee And Tea Shop',
'Coffee Merchants',
'Coffee Shop',
'Colour Analysis',
'Colour Consultancy',
'Commissioners for Oaths',
'Commodity Broking',
'Communications',
'Community Action Group',
'Community Hall / Public Venue',
'Community Nurse',
'Company Registrar',
'Company Search Agency',
'Complementary Therapies',
'Composer',
'Computer Games Shop',
'Computer Hardware Manufacturers',
'Computer Hardware Wholesalers',
'Computer Repair Service and Maintenance',
'Computer Shop - Business',
'Computer Shop - General',
'Computer Shop - Home And Games',
'Computer Supplies Shop',
'Computer Training Schools/Services',
'Concrete Services - Drilling',
'Concrete Services - Maintenance and Repair',
'Confectionery Shops',
'Conservatory Installation',
'Contracts Supervisor',
'Conveyancing',
'Copper Plate Engravers',
'Copywriting',
'Corrosion Consultancy',
'Cosmetics Shop',
'Costume / Fashion Jewellery Shop (excluding fine jewellery)',
'Couriers',
'Couriers/Delivery Services',
'Crane Erector',
'Crane Hiring',
'Crane Operator',
'Credit Investigation Agency',
'Credit Reference Agency',
'Crop Spraying',
'Curios Shop',
'Curtain and Blind Installation',
'Curtain and Blind Shops',
'Curtain Hanger',
'Curtain Wall Contractors',
'Cutlery Shop',
'Cycle Shop',
'Dairy Products Shop',
'Damp Proofing',
'Dance Instruction',
'Dancer',
'Dark / Cloud Kitchen',
'Data or network security',
'Data Processing',
'Debt Collection',
'Decorators Merchants Shop',
'Delicatessen and/or Specialist Food Shop',
'Demolition',
'Demolition Contractor',
'Dendrochronology',
'Dental Hygienist',
'Dental Technician',
'Dental Therapist',
'Dentist',
'Department Store',
'Dermatology',
'Design Consultancy',
'Design Engineering',
'Desktop Publishing Services',
'Dieticians and Nutritionists',
'Direct marketing',
'Disc Jockey',
'Dismantling Engineering (excluding machinery)',
'Distillery',
'Distillery Worker',
'District Nurse',
'DIY - Including Timber Shop',
'DIY Store',
'Docker',
'Doctor',
'Dolls/Dolls House Shop',
'Domestic Appliance Maintenance',
'Domestic Services',
'Domestic Shed Garage and Carport Erectors',
'Door to Door Seller',
'Double Glazing Installation excluding Guttering/Facia Soffit Boards',
'Drain Cleaning Contractor',
'Drainage',
'Drama Instruction',
'Draper Shop',
'Draught Proofing',
'Draughtsman',
'Dress Agency',
'Dress, Blouse and Skirt Manufacturers',
'Driller ( Civil Engineering )',
'Drilling Contractors',
'Driving Instruction',
'Drug Stores',
'Dry Cleaning',
'Dry Stone Wall Construction/Repair',
'Ductwork Installation',
'E-Cigarette / Vape Shop',
'Earth Moving Contractor',
'Earth Removing',
'Ecology',
'Economist',
'Editorial Consultancy',
'Electric Tool Shops',
'Electric Vehicle Chargepoint Installation',
'Electrical Appliance Servicing and Repair',
'Electrical Contractor',
'Electrical Domestic Goods Service & Repair Shop',
'Electrical Engineering Consultancy',
'Electrical Goods Consultancy',
'Electrical Goods Shop',
'Electrical Goods Shop - Domestic Appliances',
'Electrical Goods Shop - HI FI Audio TV etc.',
'Electrical Goods Shop - White Goods',
'Electrocardiogram Technician',
'Electronic Engineering',
'Electronic Equipment Servicing',
'Electronics Consultancy',
'Electronics Technician',
'Embryologists',
'Emergency Care Practitioner',
'Emergency Medical Technician',
'***Employment Agency - Clerical',
'Employment Agency - Manual',
'Energy Consultancy',
'Engineering Consultancy',
'Engineering Stoker',
'Engraving',
'Engraving Shop',
'Environmental Consultancy',
'Environmental Lifestyle Consultancy',
'Escalators - All Work',
'Estate Agency',
'Event and Conference Organising',
'Excavation',
'Exercise Instruction',
'Exhaust, Tyre and Windscreen Fitting',
'Exhibition Design',
'Exhibition Organiser',
'Exhibition Stand Erection',
'Export Consultancy',
'Fabric Shop',
'Fabrications',
'Face Painting',
'Factory Manager',
'Falconer',
'Family Health',
'Family Planning Agency',
'Fancy Goods Shop',
'Farm Produce Shop',
'Farm Worker',
'Farrier',
'Fashion Accessories Shop',
'Fashion Accessory Manufacturers',
'Fashion Accessory Wholesalers',
'Fashion Boutique Shop',
'Fashion Consultancy',
'Fashion Design',
'Fashion Shop',
'Fast Food Delivery Services',
'Fast food retail',
'Fencing and Hoarding Contractor',
'Fencing Contractors',
'Feng Shui Consultancy',
'Film or TV post production',
'Film Processing Shop',
'Film, TV, radio commercials',
'Financial Analyst',
'Financial Consultancy',
'Financial Services',
'Fire Protection Consultancy',
'Firearms / Weapons Supplier',
'Fireplace Installation Service and Repair (excluding woodburners)',
'Fireplace Shop',
'Fireworks Supplier',
'First Aid Training',
'First Aider',
'First Responder',
'Fish & chip shop',
'Fisheries Consultancy',
'Fishing Tackle Retailing',
'Fishmonger',
'Fitted Furniture Installation',
'Floor Cleaning Services (excluding carpets)',
'Flooring Contractor',
'Florists Shop',
'Flower and Plant Merchants',
'Flower Arranging',
'Food Industry Consultancy',
'Food Store',
'Footwear Shop',
'Forensic Nurse',
'Forensic Science',
'Forestry Consultancy',
'Fortune Telling',
'Forwarding Agent',
'Freezer Centre Shop',
'Freight Agent',
'French Polishers',
'Frozen Food Shop',
'Fuel Efficiency Consultancy',
'Garage Door Fitting',
'Garden Centre',
'Garden Design',
'Garden Equipment Shop',
'Garden Services',
'Garden Supplies Shop',
'Gas Fitting',
'Genealogy',
'General Store',
'Geneticist',
'Geology',
'Gift and Fancy Goods Shop',
'Glamping Site',
'Glass Merchants Shop',
'Glass Or Glass Goods Decorators/Engravers Shop',
'Glassware Shops',
'Glazier',
'Glazier Shop',
'Glove Manufacturers ex leather',
'Golf Equipment Retailing',
'Golf Professionals Shop',
'Gown Manufacturers',
'Gown Trade Shop',
'Graphic Design',
'Graphic or UX/UI design',
'Graphology',
'Gravediggers',
'Greengrocer',
'Greeting Card Shop',
'Greetings Card Wholesalers',
'Grocer',
'Grocer - Licenced',
'Groundsman',
'Groundwork and Paving Contractor',
'Guest House',
'Gunsmith',
'Guttering and Fascia Board Cleaning',
'Guttering and Fascia Board Installation',
'Gym / Fitness Centre',
'Gynaecology',
'Haberdashery and Draper Shop',
'Hair and Beauty Consultancy',
'Hairdressing',
'Hairdressing Salon',
'Hairpiece And Wig Shop',
'Handicraft Shop',
'Handkerchief Manufacturers',
'Hardware Shop',
'Hatter Shop',
'Haulage Contractor',
'Haulier - Heavy Plant/Machinery Movers',
'Haulier - Tankers',
'Health Advice Services',
'Health and Safety Consultancy',
'Health Centre',
'Health Coach/Holistic Nutrition Counsellor',
'Health Food Shop',
'Health Promotion Practitioner',
'Health Visitor',
'Healthcare Assistant',
'Heating Consultancy',
'Heating Engineering',
'Heating, Ventilation and Airconditioning Engineering',
'Height Safety Training Consultancy',
'Herbalism',
'Herbs and Spices Shop',
'Hobby and Model Shop',
'Holiday accommodation',
'Hollowware - Domestic - Kettles Pans Warehousing',
'Home Baker',
'Home Brew Materials Shop',
'Home Crafts',
'Home Help Services',
'Home Leisure',
'Home Tutors',
'Homeopathy',
'Horticultural Consultancy',
'Horticultural Goods Shop',
'Horticulturalist',
'Hosiery Manufacturers',
'Hosiery Shop',
'Hot Stone Therapy',
'Hot Tub Installation and Repair',
'Hotel',
'Hotel Consultancy',
'House Sitters',
'Household Goods Shop',
'Housing Association',
'Human Resources Consultancy',
'Hydro Geology',
'Hypnotherapy',
'Ice Cream Parlour',
'Ice Cream Vendor',
'Illuminated Sign Manufacturers',
'Illustrator',
'Image Consultancy',
'Import and Export Consultancy',
'In Car Entertainment Shop',
'Independent Nurse Prescriber',
'Industrial Consultancy',
'Industrial Design',
'Information Bureau',
'Inn',
'Inspection Services',
'Insurance Intermediary',
'Interim Management',
'Interior Design',
'Interior Designers Including Fitting',
'Internet Cafe',
'Internet Consultancy',
'Internet services',
'Intruder Alarm Retailing',
'Inventory Consultancy',
'Investment Consultancy',
'Ironing Services',
'Ironmonger Shop',
'IT consultancy',
'IT project management',
'Jeweller / Goldsmith (fine jewellery)',
'Jewellery Consultancy',
'Journalist',
'Kennels and Catteries',
'Key Cutting Shop',
'Kilts/Tartan Accessories Manufacturers',
'Kitchen Accessories Shop',
'Kitchen and Bathroom Design',
'Kitchen Design and Installation',
'Kitchen Equipment Manufacturers',
'Kitchen/Bathroom Unit Showroom',
'Knitting Machine Shop',
'Knitwear Manufacturers',
'Knitwear Shop',
'Label Printing',
'Laboratory Technician',
'Lactation Consultant',
'Lamp Shop',
'Land Surveying',
'Landlord',
'Landscape Consultancy',
'Landscape Gardening',
'Late Night Bar',
'Launderette - Attended',
'Launderette - Unattended',
'Leaflet Distribution',
'Learning Disabilities Support Worker',
'Lease Broking',
'Leather Clothing Shop',
'Leather Goods Shop - Excluding Clothes',
'Leather Goods Shop (Including Clothes)',
'Legal Services',
'Leisurewear Shop',
'Library',
'Licensing Consultancy',
'Life Style Consultancy',
'Lift Engineering',
'Lift Installation',
'Lift Maintenance',
'Light Fitting Shop',
'Light Metal Fabrication',
'Lighting Consultancy',
'Lighting Installation',
'Lighting Shop',
'Lighting Technician',
'Lightning Conductor Contractors',
'Linen Hire',
'Linen Shop',
'Lingerie Manufacturers',
'Lingerie Shop',
'Linguistics',
'Lithographic and Offset Printing',
'Lithographic Plate Makers',
'Live Music Venue',
'Locksmith Shop',
'Locksmiths',
'Locum - General Practitioner',
'Loft Converter',
'Loft Insulation',
'Loss Adjusting',
'Loss Assessing',
'Luggage And Handbag Shop',
'Lumberjack',
'Lymphedema Nurse',
'Machinery Dismantling',
'Machinery Installation',
'Machinery Movement',
'Machinery Repair and Maintenance',
'Mail Order Retailer',
'Managed services',
'Management Consultancy',
'Manicurists and Pedicurists',
'Manufacturing Agency',
'Marine Broking',
'Marine Consultancy',
'Marine Geology',
'Marine Shop',
'Market Food Stall',
'Market Research',
'Market Trading (excluding food stalls)',
'Marketing Consultancy',
'Marketing or advertising',
'Marketing, Advertising, Communications',
'Marquee Hire',
'Marriage Guidance',
'Mastic Sealant Contractors - Internal',
'Maternity Wear Shop',
'Mechanic - Mobile',
'Mechanical Engineering',
'Media buying',
'Medical Consultancy',
'Medical Radiation Scientist',
'Medical Research',
'Menswear Shops',
'Mental Health Support Workers',
'Meteorology',
'Meter Reading',
'Micro Brewery',
'Microbiology',
'Milk Delivery',
'Millinery Shop',
'Mineral, Sand and Gravel Extraction',
'Mineralogy',
'Mobile Food Van',
'Mobile Phone Retailing',
'Mobility Shop',
'Model Agency',
'Model Shop',
'Monumental Masons',
'Mortgage Broking',
'Motel',
'Motorbike Accessories Shop',
'Motorbike Parts Shop',
'Museum',
'Music Publisher',
'Music Shop',
'Music Teaching',
'Musical Instrument Shop',
'Musicians',
'Nail Technicians',
'Nanny / Child Care',
'Nappy Service',
'Naturopathy',
'Naval Architect',
'Newsagents',
'Nightclub',
'Non Manual Site Supervision',
'Non-Destructive Testing Services',
'Notaries Public',
'Novelty/Carnival Goods Shop',
'Nurse Anaesthetists',
'Nurse Dental',
'Nurse General',
'Nurse Mental Health',
'Nurse Paediatric',
'Nurse Prescriber',
'Nursery Goods Shop',
'Nursing Associate',
'Nursing Auxiliary',
'NVQ Assessing',
'Occupational Health Consultancy',
'Occupational Therapists',
'Off Licence',
'Office equipment supplier',
'Office Equipment Supplier (Excluding Electrical) Shop',
'Office Equipment Supplier (Including Electrical) Shop',
'Office Furniture Shop',
'Office Supplies Shop',
'Online Retailers',
'Operating Dept Practitioner',
'Ophthalmic Nurse',
'Opticians',
'Optometrist',
'Organic Foods Shop',
'Ornithology',
'Orthopaedic Equipment Retailers',
'Orthoptics',
'Orthotist / Prosthesis',
'Osteopathy',
'Oven Builders',
'Overhead Line Instruction',
'Overhead Lineman',
'Paint And/Or Wallpaper Shop',
'Paint Consultancy',
'Paint Spraying',
'Painter and Decorator',
'Palaeobotany',
'Palliative Nurse',
'Paramedic',
'Paramedic Practitioner',
'Partition Contractors',
'Party Planners',
'Patent/Trademark Agents',
'Pathology',
'Paving Drive Patio and Path Laying',
'Pawnbroker',
'Pebble Dashers',
'Pedorthist',
'Pens Shop',
'Perambulator Shop',
'Perfume Shop',
'Perfusionists',
'Personal Shopping Services',
'Pest and Vermin Control',
'Pet Accessory/Food Shop',
'Pet Grooming',
'Pet Grooming Salon',
'Pet Minding',
'Pet Parlour',
'Pet Shop',
'Pet Walkers',
'Petrol Pump Maintenance',
'Petrol Station',
'Pharmacists',
'Pharmacy',
'Pharmacy Technicians',
'Phlebotomist',
'Photo Engraving Shop',
'Photo Processing And Printing Shop',
'Photobooth Hire / Operator',
'Photocopying',
'Photocopying Shop',
'Photographic Agent',
'Photographic Equipment Repair',
'Photographic Equipment Shop',
'Photographic Studio',
'Photography',
'Physicians',
'Physiotherapists',
'Piano Shop',
'Piano Shop And Repairs',
'Piano Tuners and Repairers',
'Picture Framing Shop',
'Picture Shop',
'Pilates Instruction',
'Pile Driving and Piling Contractors',
'Pine And Cane Furniture Shop',
'Pipe Cleaning',
'Pipe Fitter',
'Pipe Laying',
'Pipeline Consultancy',
'Pizza Delivery',
'Planning Consultancy',
'Plant Fitter',
'Plant Hire',
'Plant Manager',
'Plant Operator',
'Plastering/Dry Lining Contractor',
'Plastic Product Fabricators',
'Plastics Consultancy',
'Playground Equipment Installation',
'Plumber',
'Plumbers Merchant Shop',
'Pointsman',
'Political Consultancy',
'Political Party',
'Pool And Snooker Table Shop',
'Pop Up Shop',
'Post Office - Sub',
'Pottery',
'Poultry And Game Shop',
'Practice Nurse',
'Preaching',
'Precision Engineering',
'Pregnancy Testing Services',
'Premises Security (excluding locksmiths) Installation',
'Press Cutting Agency',
'Press Office',
'Pressure Cleaning (Excluding blast and tank cleaning)',
'Print Finishing Manufacturers',
'Print Shop',
'Printing Press',
'Prison Nurse',
'Private Investigation',
'Product Design Services',
'Professional Association',
'Project Management',
'Promotional Consultancy',
'Proof Reading',
'Property Auditors',
'Property Consultancy',
'Property Developer',
'Property Inventories',
'Property Letting',
'Property Maintenance',
'Property Management',
'Property owner',
'Property Services',
'Property Valuers',
'Proprietor',
'Pub',
'Public Records Search Company',
'Publishing',
'Publishing (digital or print)',
'Pump and Pumping Equipment Servicing',
'Quality Assurance',
'Quantity Surveying',
'Radiographer',
'Record CD Cassette And Video/DVD Shop',
'Record Shop',
'Recruitment Consultancy',
'Reflexology',
'Refrigeration Engineering',
'Refuse Treatment Consultancy',
'Reiki Healing',
'Relocation Agency',
'Remedial Therapy',
'Removal Contractor',
'Renal Dialysis Technologist',
'Repatriation Nurse / Flight Nurse / Off Shore',
'Residents Association',
'Respiratory Therapist',
'Restaurant',
'Rigging Contractors - Theatrical and Entertainment',
'Riveter',
'Road Surfacing',
'Roller Shutter Door Installation',
'Roofer',
'Rope Merchant Shop',
'Saddlery And Tack Shop',
'Safe Installation and Removal',
'Sailing Equipment Supplier Shop',
'Sandwich Bar',
'Sandwich Delivery',
'Santa Claus / Father Christmas',
'Santa\'s Grotto',
'SAP implementation',
'sc',
'Scaffolding Erection',
'Scaffolding Hire',
'School Nurse',
'Schools and Colleges',
'Scientific Instrument Shop',
'Scientific Research',
'Screen Printing',
'Screenwriter',
'Script Writing',
'Sculptors',
'Secretarial Services',
'Security Consultancy',
'Security Services',
'SEO or PPC consultancy',
'Sewage Consultancy',
'Sewing Machine Shop',
'Sex Shop',
'Sheet Metal Work',
'Shiatsu Advanced',
'Shiatsu Practitioners',
'Ship Broking',
'Ship Painting',
'Ship Repairing',
'Shipping and Forwarding Agent',
'Shirt Shop',
'Shisha Lounge / Restaurant',
'Shoe Repairing Shop',
'Shoe Shop',
'Shoeshiner / Boot Polishing',
'Shop and Office Fitting',
'Shuttering and Formwork',
'Sign and Poster Maintenance Contractors',
'Sign Erectors',
'Sign Maker',
'Signwriting',
'Silverware - Shop',
'Site Clearance Waste Removal',
'Site Investigation',
'Skip Hire',
'Smart Home Installation',
'Social Worker',
'Sofa Bed Shop',
'Soft Furnishings and Linen Shop',
'Software and IT Services',
'Software development',
'Solar Panel Supplier',
'Solicitors',
'Sound Equipment Installation',
'Sound Proofing',
'Souvenir - Shop',
'Specialist Paramedic',
'Speech and Language Therapy',
'Speech and Language Therapy',
'Speech Therapy',
'Sports and Personal Training',
'Sports Goods Shop',
'Sports Promotion',
'Sports Therapy',
'Sportswear Supplier Shop',
'Sprinkler Installation',
'Stair Lift Installation/Repair',
'Stationer Shop',
'Statisticians',
'Steel Erectors',
'Steel Reinforcing Rod Installation',
'Steel Worker',
'Steeplejacks',
'Sterile Processing Technician',
'Stockbroking',
'Stocktaker and Valuer',
'Stone Cladding',
'Stone Cleaners and Restorers',
'Stonemasonry',
'Street Lighting Installation',
'Structural Engineering',
'Structural Steelwork Contractors',
'Sunglasses Shop',
'Supermarket',
'Surface Coating Consultancy',
'Surgical Equipment Shops',
'Surveying',
'Sweet Shop',
'Swimming Pool Cleaning',
'Swimming Pool Construction (Outdoors)',
'Swimming Pool Installation and Repair',
'T-Shirt Printing',
'Tableware Shop',
'Tachograph Analysis',
'Tailor and Outfitter',
'Tailor and Outfitter Shop',
'Take Away Food Supplier',
'Tank Cleaning Services',
'Tattoo and Piercing Shop',
'Tax Consultancy',
'Taxi Operator',
'Taxidermy',
'Tea Room',
'Technical Author',
'Telecommunication Equipment Supplier Shop',
'Telecommunications Consultancy',
'Telecommunications Engineering',
'Telecoms/ISP/VoIP',
'Telegraph Pole Installation',
'Telemarketing',
'Telephone Answering Services',
'Telesales',
'Television Hiring',
'Television Repairing Shop',
'Television Shop',
'Tent and Marquee Erection',
'Textile Consultancy',
'Textile Printing',
'Textile Shop',
'Thatching',
'Theatre Nurse',
'Thermal Insulation',
'Ticket Agency',
'Tie Scarf and Neckwear Manufacturers',
'Tile Shop',
'Tilers',
'Timber Decking Contractors',
'Timber Treatment Consultancy',
'Timber Worker',
'Toaster Manufacturers',
'Toastmastering',
'Tobacconist',
'Toiletries Shop',
'Tool Shop',
'Tourist Information',
'Town Planning',
'Toy And Game Shop',
'Trade Association',
'Trade Union',
'Trading Standards Consultancy',
'Traffic Consultancy',
'Training Consultancy',
'Translation',
'Travel Agency - Not Bureau De Change',
'Travel Consultancy',
'Travel Health Nurse',
'Tree Surgeon',
'Trichology',
'Trophy Shop',
'Tuition',
'Tunnelling Contractor',
'Tupperware',
'Turfing Services',
'TV and Audio Installation and Repair (excluding aerial and satellite dish installation)',
'TV And Radio Shop',
'TV And Video Rental',
'TV And Video Rental Shop',
'TV And Video Repairing Shop',
'TV, radio, online broadcasters',
'Typesetters',
'Typing and Copying Bureau',
'Underpinning Contractors',
'Underwriting Agency',
'Uniform Manufacturers',
'Uniform Shop',
'Upholstery',
'UPVC Window and Door Manufacturers and Installers',
'Vascular Nurse',
'Vending Machine Operator',
'Venetian Blind Supplier Shop',
'Veterinary Nurse',
'Videography',
'Vinegar Brewers',
'Wallpaper Shops',
'Waste Disposal',
'Watch And Clock Shop',
'Water Treatment Contractors',
'Waterways Maintenance',
'Weather Forecasting',
'Website Design',
'Welders',
'Wheelie Bin Cleaners',
'Will Writer',
'Window and Door Showroom',
'Window Cleaning',
'Window Manufacturers and Installers (UPVC)',
'Window Surveying',
'Wine Shop',
'Woodworking Machinist',
'Woodworm and Dry Rot Control',
'Wool And Needlework Shop',
'Woollen Goods Shop',
'Yacht Chandlery Shop',
'Yoga Instruction',
'Zoology',
];

export default industries; 